window.addEventListener('load', () => {
	setTimeout(() => {

	const initSlider = () => {
		const sliders = document.querySelectorAll(".swiper-container");

		sliders.forEach((slider) => {

			if (!slider || slider.classList.contains("slider_started")) {
				return;
			}

			slider.classList.add("slider_started");

			new Swiper(slider, {
				slidesPerView: 1,
				speed: 250,
				spaceBetween: 0,
				navigation: {
					nextEl: slider.querySelector(".swiper-button-next-1"),
					prevEl: slider.querySelector(".swiper-button-prev-1"),
				},
				pagination: {
					el: slider.querySelector(".product-card-pagination"),
					clickable: true,
				},
			});

		});
	};

	initSlider();

	document.addEventListener("shopify:section:load", function () {
		initSlider();
	});
	}, 1500);
});

